/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchOperationV2TeamShotStatistics } from './MatchOperationV2TeamShotStatistics';
import {
    MatchOperationV2TeamShotStatisticsFromJSON,
    MatchOperationV2TeamShotStatisticsFromJSONTyped,
    MatchOperationV2TeamShotStatisticsToJSON,
    MatchOperationV2TeamShotStatisticsToJSONTyped,
} from './MatchOperationV2TeamShotStatistics';

/**
 * Totals from all effective shot and possession events, including unattributed shots and saves, with corrected events excluded.
 * @export
 * @interface MatchOperationV2TeamStatistics
 */
export interface MatchOperationV2TeamStatistics {
    /**
     * 
     * @type {MatchOperationV2TeamShotStatistics}
     * @memberof MatchOperationV2TeamStatistics
     */
    teamA: MatchOperationV2TeamShotStatistics;
    /**
     * 
     * @type {MatchOperationV2TeamShotStatistics}
     * @memberof MatchOperationV2TeamStatistics
     */
    teamB: MatchOperationV2TeamShotStatistics;
}

/**
 * Check if a given object implements the MatchOperationV2TeamStatistics interface.
 */
export function instanceOfMatchOperationV2TeamStatistics(value: object): value is MatchOperationV2TeamStatistics {
    if (!('teamA' in value) || value['teamA'] === undefined) return false;
    if (!('teamB' in value) || value['teamB'] === undefined) return false;
    return true;
}

export function MatchOperationV2TeamStatisticsFromJSON(json: any): MatchOperationV2TeamStatistics {
    return MatchOperationV2TeamStatisticsFromJSONTyped(json, false);
}

export function MatchOperationV2TeamStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationV2TeamStatistics {
    if (json == null) {
        return json;
    }
    return {
        
        'teamA': MatchOperationV2TeamShotStatisticsFromJSON(json['teamA']),
        'teamB': MatchOperationV2TeamShotStatisticsFromJSON(json['teamB']),
    };
}

export function MatchOperationV2TeamStatisticsToJSON(json: any): MatchOperationV2TeamStatistics {
    return MatchOperationV2TeamStatisticsToJSONTyped(json, false);
}

export function MatchOperationV2TeamStatisticsToJSONTyped(value?: MatchOperationV2TeamStatistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teamA': MatchOperationV2TeamShotStatisticsToJSON(value['teamA']),
        'teamB': MatchOperationV2TeamShotStatisticsToJSON(value['teamB']),
    };
}

